import config from '../../../config';
import { SanitySubscription } from '../../../models/subscription-comparison/ComparableSubscriptions';
import { PartnerIframeConfig } from '../../../models/subscription-comparison/PartnerIframeConfig';

export const getSubscriptionsForPartner = async (partnerAlias: string, dwellingUnit: string): Promise<SanitySubscription[]> => {
  return fetch(`${config.apiUrl}/campaign/${partnerAlias}/${dwellingUnit}`).then((response) => response.json());
};

export const getPartnerIframeConfig = async (partnerAlias: string): Promise<PartnerIframeConfig | null> => {
  const response = await fetch(`${config.apiUrl}/partner/${partnerAlias}/iframeconfig`);
  if (response.status === 204) return null;
  return response.json() as PartnerIframeConfig;
};
